import React from 'react';
import { Hash } from 'lucide-react';
import { initials, avatarColor } from '../chatHelpers';
import AvatarShell from './AvatarShell';

/**
 * Channel/group avatar — the counterpart to UserAvatar for non-DM
 * conversations. Renders the channel's uploaded image (`channel.avatar_url`)
 * when present, else a Hash glyph (channels) or initials (groups) on the
 * channel's chosen `color` (falling back to the deterministic avatarColor).
 *
 * Also used for the live preview in NewChannelModal: pass a channel-like object
 * `{ kind, color, avatar_url }` where avatar_url can be a local object URL.
 */
export default function ChannelAvatar({ channel, name, seed, size, className = '', style = {}, children }) {
  const src = channel?.avatar_url || null;
  const bg = channel?.color || avatarColor(seed ?? channel?.id ?? name);
  const sizeStyle = size != null ? { width: size, height: size } : {};
  const iconSize = size != null ? Math.max(12, Math.round(size * 0.5)) : 16;

  const fallback =
    channel?.kind === 'channel' ? <Hash size={iconSize} aria-hidden /> : initials(name);

  return (
    <AvatarShell
      src={src}
      bg={bg}
      fallback={fallback}
      sizeStyle={sizeStyle}
      className={className}
      style={style}
    >
      {children}
    </AvatarShell>
  );
}
